<template>
    <div class="kgr-row">
        <kgr-form-row
            :label="$t('field.name')"
            :error="error"
            field-name="name"
            required
        >
            <input
                v-model.trim="field.name"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('field.note')"
            :error="error"
            field-name="note"
        >
            <textarea
                v-model.trim="field.note"
                class="kgr-input"
                rows="5"
            ></textarea>
        </kgr-form-row>

        <kgr-form-row
            :label="$t('field.size')"
            :error="error"
            field-name="size"
        >
            <input
                v-model.number="field.size"
                type="number"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>

        <kgr-form-row
            :label="$t('field.maxPersons')"
            :error="error"
            field-name="maxPersons"
        >
            <input
                v-model.number="field.maxPersons"
                type="number"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            />
        </kgr-form-row>
    </div>
</template>

<script>
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';

export default {
    components: {
        'kgr-form-row': FormRow,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },

}

</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
